module.exports = __webpack_public_path__ + "static/media/search-gradient.948ad2d8.svg";